import React from 'react'
import { I18n } from '@front/volcanion'

import { TableCell } from '@mui/material'
import TextHeader from '@abra/elements/table/headers/Text'

const Header = props => <>
  <TableCell align='center'>
    <TextHeader label={I18n.t('name.label', { count: 1 })} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('rateparameter.flat_rate')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('rateparameter.km_rate')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('rateparameter.hour_rate')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('rateparameter.min_rate')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('rateparameter.max_rate')} />
  </TableCell>
  <TableCell align='center'>
    <TextHeader label={I18n.t('rateparameter.handling_rate')} />
  </TableCell>
</>

export default React.memo(Header)
